/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import {
  Button,
  DatePicker,
  Select,
  Tabs,
  message,
  Menu,
  Dropdown,
  Checkbox,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import {
  solarPlantSelection,
  getSolarInverterGroup,
  solarPlantDetails,
  getSolarStorageGroup as getSolarStorageGroupDetails,
} from 'api/pgads'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import { exportData, getApiTargetInfo, rowHeaderRender } from 'core'
import { Content, CriteriaRow, FullHeightSizer, Title } from 'core/screen-util'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import {
  SolarInverterGroupHeaders,
  SolarNercEventIoHeaders,
  SolarPerformanceIoHeaders,
  SolarPlantHeaders,
  SolarStorageGroupHeaders,
  SolarStoragePerformanceIoHeaders,
} from 'solar/Headers'

import {
  InverterGroupHeaders,
  NercEventIoHeaders,
  PerformanceIoHeaders,
  PlantHeaders,
  StoragePerformanceIoHeaders,
} from './solarHeader'
import {
  getEnergyStoragePerformance,
  getEventListXML,
  getInverterGroupPerformance,
  getInverterGroupXML,
  getPlantXML,
  getStorageGroupXML,
} from './xmldata'
import {
  getSolarStorageGroup,
  solarFileEnergyStoragePerformance,
  solarFileEvent,
  solarFileInverterGroup,
  solarFileInverterGroupPerformance,
  solarFilePlants,
} from 'solar/solarapi'
import {
  JcTmpErrorTable,
  isErrorContains,
} from '../../core/component/JcTmpErrorDialog'
import {
  getPlantXLSX,
  getEnergyStoragePerformanceXLSX,
  getEventListXLSX,
  getInverterGroupPerformanceXLSX,
  getInverterGroupXLSX,
  getInverterEventGroupPerformanceXLSX,
  getEnergyStorageXLSX,
} from './excelData'
import R from 'ramda'
import { writeToExcel } from 'core/component/xlsx-utils-excel'
import { saveAs } from 'file-saver'
import moment from 'moment'
import {
  getValidPlantList,
  getValidActivePlantList,
  getValidActivePlantWithStorageGroup,
} from '../util'
// import SolarPlantSelection from '../SolarPlantSelection'
import { Filler } from '../../core/screen-util'

const PLANT = 'Plant'
const INVERTER = 'Inverter'
const EVENT = 'Event'
const INVERTER_GROUP_PERFORMANCE = 'Inverter_Performance'
const EVENT_INVERTER_PERFORMANCE = 'Event_Inverter_Performance'
const ENERGY_STORAGE_PERFORMANCE = 'Energy_Storage_Performance'
const ENERGY_STORAGE = 'Energy_Storage'
const XML = 'xml'
const EXCEL = 'excel'

const SolarFileCreation = ({ targetInfo }) => {
  const [data, setData] = useState([])
  const [data2, setData2] = useState([])
  const [activeKey, setActiveKey] = useState('data')
  const [platAllList, setPlantAllList] = useState([])
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const [jcTmpErrors, setJcTmpErrors] = useState([])
  const [plantSelected, setPlantSelected] = useState([])

  const [selectedType, setSelectedType] = useState(EVENT_INVERTER_PERFORMANCE)
  const [plantNameMap, setPlantNameMap] = useState({})
  const [isRetrieved, setIsRetrived] = useState(false)
  const [activePlants, setActivePlants] = useState([])

  const onChange = _ => {
    setData([])
    setData2([])
    setJcTmpErrors([])
    setIsRetrived(false)
    setActiveKey('data')
    // setPlantSelected([])
  }

  useEffect(
    _ => {
      solarPlantSelection(targetInfo)({
        year: selectedDateRangePicker[1].format('YYYY'),
        month: selectedDateRangePicker[1].format('MM'),
      }).fork(setError, data => {
        setPlantList(data)
      })
      solarPlantDetails(targetInfo).fork(setError, data => {
        setActivePlants(
          data.filter(f => f.plantOwnershipStatus === 'AV').map(f => f.plantId)
        )
      })
    },
    [selectedDateRangePicker, setError, targetInfo]
  )

  const [plantList, setPlantList] = useState([])
  const [inverterGroupList, setInverterGroupList] = useState([])
  const [storageGroupList, setStorageGroupList] = useState([])

  useEffect(
    _ => {
      // let stoList = []

      const stoList = getValidPlantList(plantList, inverterGroupList, [])
      const sd = R.sortBy(R.prop('plantName'), stoList)
      setPlantAllList(sd)
      const namMap = R.compose(
        R.fromPairs,
        R.map(s => [s.plantId, s.plantName])
      )(sd)
      setPlantNameMap(namMap)
      // if (sd[0] && sd[0].plantId && plantSelected.length === 0)
      //   setPlantSelected(sd[0].plantId)
    },
    [inverterGroupList, plantList]
  )
  useEffect(
    _ => {
      getSolarInverterGroup(targetInfo).fork(setError, setInverterGroupList)
      getSolarStorageGroupDetails(targetInfo).fork(
        setError,
        setStorageGroupList
      )
    },
    [setError, targetInfo]
  )

  const sortPerformacneData = data => {
    return R.sortBy(
      (a, b) => {
        if ((a.subgroupName || '') === 'TOTAL') return 100000
        else {
          return R.toLower((a && a.inverterGroupName) || '').localeCompare(
            R.toLower((b && b.inverterGroupName) || '')
          )
        }
      },
      // data.filter(f => f.inverterGroupName !== 'TOTAL' && f.recordid !== 'NOT')
      data.filter(f => f.inverterGroupName !== 'TOTAL')
    )
  }

  const sortEventData = pd => {
    //  return pd.filter(f => f.recordId !== 'NOT')
    return pd
  }

  const retrieveData = _ => {
    if (!plantSelected || plantSelected.length <= 0) {
      message.warn('Please, Select Plant.')
      return
    }
    if (!selectedType) {
      message.warn('Please, Select Data/XML Type.')
      return
    }
    const req = {
      plants: plantSelected,
      start: selectedDateRangePicker[0]
        .clone()
        .startOf('M')
        .format('YYYY-MM-DD'),
      end: selectedDateRangePicker[1]
        .clone()
        .endOf('M')
        .format('YYYY-MM-DD'),
    }
    const api =
      selectedType === PLANT
        ? solarFilePlants
        : selectedType === INVERTER
        ? solarFileInverterGroup
        : selectedType === EVENT
        ? solarFileEvent
        : selectedType === INVERTER_GROUP_PERFORMANCE ||
          selectedType === EVENT_INVERTER_PERFORMANCE
        ? solarFileInverterGroupPerformance
        : selectedType === ENERGY_STORAGE_PERFORMANCE
        ? solarFileEnergyStoragePerformance
        : selectedType === ENERGY_STORAGE
        ? getSolarStorageGroup
        : solarFilePlants

    setSpinning(true)
    api(targetInfo)(req).fork(setError, res => {
      const { data, event = [], errors } = res
      setSpinning(false)
      setIsRetrived(true)
      const errorsNew = []
      const filteredData = new Map()

      const perfDataValidate = pd =>
        pd.forEach(e => {
          if (e.entityId && e.plantId && e.recordid && e.recordid === 'NOT') {
            // if (e.entityId && e.plantId) {
            const key = e.entityId + '-' + e.plantId
            if (!filteredData.has(key)) {
              filteredData.set(key, e)
              if (e.recordid === 'NOT')
                errorsNew.push({
                  severity: 1,
                  errorCode: 0,
                  errorMessage: `Plant ${plantNameMap[e.plantId] ||
                    e.plantId} is not level 2 validated in ${
                    e.year
                  }-${e.month.toString().padStart(2, '0')}`,
                })
            }
          }
        })

      if (selectedType === PLANT) setData(setPlantSortData(data))
      else if (selectedType === ENERGY_STORAGE_PERFORMANCE) {
        setData(setStoragePerfData(data))
      } else if (selectedType === INVERTER_GROUP_PERFORMANCE) {
        setData(sortPerformacneData(data))
        perfDataValidate(data)
      } else if (selectedType === EVENT_INVERTER_PERFORMANCE) {
        setData2(sortEventData(R.uniq(event)))
        setData(sortPerformacneData(data))
        perfDataValidate(data)
      } else if (selectedType === EVENT) {
        setData(sortEventData(R.uniq(data)))
      } else if (selectedType === ENERGY_STORAGE) {
        const dt = data.map(d => ({
          ...d,
          commisionDate:
            d.commisionDate && moment(d.commisionDate).format('MM/DD/YYYY'),
          effectiveDate:
            d.effectiveDate && moment(d.effectiveDate).format('MM/DD/YYYY'),
        }))
        setData(dt)
      } else setData(data)

      let errs = [...errorsNew, ...errors]
      errs = R.sortWith([
        R.descend(R.prop('severity')),
        R.ascend(R.prop('errorCode')),
        R.ascend(R.prop('errorMessage')),
      ])(errs)
      isErrorContains(errs) && setActiveKey('errors')
      setJcTmpErrors(errs)
    })
  }

  const setPlantSortData = data =>
    data.map(d => ({
      ...d,
      effectiveDate:
        // d.effectiveDate && moment(d.effectiveDate).format('MM/DD/YYYY'),
        d.effectiveDate,
    }))

  const setStoragePerfData = data =>
    R.sortBy(
      (a, b) => {
        if ((a.storageGroupId || '') === 'TOTAL') return 100000
        else {
          return R.toLower((a && a.storageGroupId) || '').localeCompare(
            R.toLower((b && b.storageGroupId) || '')
          )
        }
      },
      data.filter(f => f.storageGroupId !== 'TOTAL')
    )

  const xmlString = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return getPlantXML(data)
        case INVERTER:
          return getInverterGroupXML(data)
        case EVENT:
          return getEventListXML(data)
        case INVERTER_GROUP_PERFORMANCE:
        case EVENT_INVERTER_PERFORMANCE:
          return getInverterGroupPerformance(data)
        case ENERGY_STORAGE_PERFORMANCE:
          return getEnergyStoragePerformance(data)
        case ENERGY_STORAGE:
          return getStorageGroupXML(data)
      }
    },
    [data, selectedType]
  )

  const solarHeaders = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return SolarPlantHeaders
        case INVERTER:
          return SolarInverterGroupHeaders
        case EVENT:
          return SolarNercEventIoHeaders(1000, [], [], true)
        case INVERTER_GROUP_PERFORMANCE:
        case EVENT_INVERTER_PERFORMANCE:
          return SolarPerformanceIoHeaders([], true)
        case ENERGY_STORAGE_PERFORMANCE:
          return SolarStoragePerformanceIoHeaders
        case ENERGY_STORAGE: {
          return SolarStorageGroupHeaders
        }
      }
    },
    [selectedType]
  )

  const headers = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return PlantHeaders
        case INVERTER:
          return InverterGroupHeaders
        case EVENT:
          return NercEventIoHeaders(1000, [])
        case INVERTER_GROUP_PERFORMANCE:
        case EVENT_INVERTER_PERFORMANCE:
          return PerformanceIoHeaders
        case ENERGY_STORAGE_PERFORMANCE:
          return StoragePerformanceIoHeaders
        case ENERGY_STORAGE: {
          const ds = R.compose(
            R.sortWith([R.ascend(R.prop('xo'))]),
            R.map(d => ({ ...d, display: d.xd })),
            R.filter(d => d.xd)
          )(SolarStorageGroupHeaders)
          return ds
        }
      }
    },
    [selectedType]
  )

  const effectivePlant = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return platAllList
        case INVERTER:
        case INVERTER_GROUP_PERFORMANCE:
        case EVENT:
        case EVENT_INVERTER_PERFORMANCE:
          return getValidActivePlantList(
            platAllList,
            inverterGroupList,
            activePlants
          )
        case ENERGY_STORAGE_PERFORMANCE:
        case ENERGY_STORAGE:
          return getValidActivePlantWithStorageGroup(
            platAllList,
            storageGroupList,
            activePlants
          )
      }
    },
    [
      selectedType,
      platAllList,
      inverterGroupList,
      storageGroupList,
      activePlants,
    ]
  )

  const excelData = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return getPlantXLSX(data, headers)
        case INVERTER:
          return getInverterGroupXLSX(data, headers)
        case EVENT:
          return getEventListXLSX(data, headers)
        case INVERTER_GROUP_PERFORMANCE:
          return getInverterGroupPerformanceXLSX(data, headers)
        case EVENT_INVERTER_PERFORMANCE:
          return getInverterEventGroupPerformanceXLSX(
            data,
            headers,
            data2,
            NercEventIoHeaders(1000, [])
          )
        case ENERGY_STORAGE_PERFORMANCE:
          return getEnergyStoragePerformanceXLSX(data, headers)
        case ENERGY_STORAGE:
          return getEnergyStorageXLSX(data, headers)
      }
    },
    [data, selectedType, headers, data2]
  )

  const exportXMLFile = _ => {
    if (selectedType !== EVENT_INVERTER_PERFORMANCE)
      exportData(
        new Blob([xmlString]),
        'text/plain',
        'SOLAR_' + selectedType + '.xml'
      )
    else {
      exportData(
        new Blob([getEventListXML(data2)]),
        'text/plain',
        'SOLAR_' + EVENT + '.xml'
      )
      exportData(
        new Blob([xmlString]),
        'text/plain',
        'SOLAR_' + INVERTER_GROUP_PERFORMANCE + '.xml'
      )
    }
    // setIsRetrived(false)
    // onChange()
  }

  const exportXLSXFile = async _ => {
    const fileName = 'SOLAR_' + selectedType
    const userId = 'GADS'

    const fileBlob = await writeToExcel(excelData, userId)
    saveAs(fileBlob, fileName)
    // setIsRetrived(false)
    // onChange()
  }
  const handleExport = e => {
    if (e.key === XML) exportXMLFile()
    else if (e.key === EXCEL) exportXLSXFile()
  }
  const menu = (
    <Menu onClick={handleExport}>
      <Menu.Item key={XML}>XML</Menu.Item>
      <Menu.Item key={EXCEL}>EXCEL</Menu.Item>
    </Menu>
  )

  return (
    <div>
      <CriteriaRow
        css={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns:
            '250px 300px 250px  150px 130px 130px 130px 1fr auto',
          gap: 15,
        }}
      >
        <Title>Solar NERC File Creation</Title>

        <Select
          showSearch
          value={selectedType}
          style={{ width: '100%' }}
          onChange={plantId => {
            setSelectedType(plantId)
            setPlantSelected([])
            onChange()
          }}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          <Select.Option
            key={EVENT_INVERTER_PERFORMANCE}
            value={EVENT_INVERTER_PERFORMANCE}
          >
            Event & Inverter Performance
          </Select.Option>
          <Select.Option key={EVENT} value={EVENT}>
            Events
          </Select.Option>
          <Select.Option
            key={INVERTER_GROUP_PERFORMANCE}
            value={INVERTER_GROUP_PERFORMANCE}
          >
            Inverter Performance
          </Select.Option>
          <Select.Option
            key={ENERGY_STORAGE_PERFORMANCE}
            value={ENERGY_STORAGE_PERFORMANCE}
          >
            Storage Performance
          </Select.Option>
          <Select.Option key={PLANT} value={PLANT}>
            Plant
          </Select.Option>
          <Select.Option key={INVERTER} value={INVERTER}>
            Inverter Group
          </Select.Option>

          <Select.Option key={ENERGY_STORAGE} value={ENERGY_STORAGE}>
            Storage
          </Select.Option>
        </Select>

        <DatePicker.RangePicker
          allowClear={false}
          mode={['month', 'month']}
          format="MMM-YYYY"
          value={selectedDateRangePicker}
          placeholder={['Start month', 'End month']}
          onChange={value => {
            setSelectedDateRagePicker([
              value[0].startOf('month'),
              value[1].endOf('month'),
            ])
            onChange()
          }}
          onPanelChange={value => {
            setSelectedDateRagePicker([
              value[0].startOf('month'),
              value[1].endOf('month'),
            ])
            onChange()
          }}
        />
        {/* <SolarPlantSelection
          plantList={effectivePlant}
          onOk={setPlantSelected}
          defaultTargetKeys={plantSelected}
          onCancel={_ => {}}
        /> */}
        <Button
          type="primary"
          onClick={retrieveData}
          icon="file-add"
          style={{ width: '100%' }}
          disabled={isRetrieved}
          className="createFile"
        >
          Create File
        </Button>

        <Dropdown overlay={menu} disabled={!isRetrieved}>
          <Button
            type="primary"
            //   onClick={importType === XML ? exportXMLFile : exportXLSXFile}
            icon="caret-right"
            style={{ width: '100%' }}
            // disabled={data.length <= 0}
            //  disabled={!isRetrieved}
            className="continue"
          >
            Continue
          </Button>
        </Dropdown>

        <Button
          type="danger"
          onClick={onChange}
          icon="stop"
          style={{ width: '100%' }}
          // disabled={data.length <= 0}
          disabled={!isRetrieved}
          className="abort"
        >
          Abort
        </Button>
        <Filler />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '10px',
          }}
        >
          <Button
            style={{ width: '150px' }}
            type="primary"
            onClick={_ => {
              const plAll = effectivePlant.map(({ plantId }) => plantId)
              setPlantSelected(plAll)
              onChange()
            }}
          >
            Select All Plant
          </Button>
          <Button
            style={{ width: '150px' }}
            type="primary"
            onClick={_ => {
              setPlantSelected([])
              onChange()
            }}
          >
            Clear All Plant
          </Button>
        </div>
      </CriteriaRow>
      <CriteriaRow css={{ paddingTop: '0px' }}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            alignContent: 'flex-start',
            height: effectivePlant.length < 10 ? '10vh' : '15vh',
            maxHeight: '20vh',
            overflow: 'auto',
            border: '1px solid #eee',
            borderRadius: '5px',
            padding: '10px',
            // paddingBottom: '10px',
          }}
        >
          {effectivePlant.map(({ plantName, plantId }) => (
            <div
              key={plantId}
              style={{
                flex1: `0 0 100px`,
                width: '250px',
                overflow: 'hidden',
              }}
            >
              <Checkbox
                key={plantId}
                style={{ display: 'block' }}
                checked={plantSelected.includes(plantId)}
                // eslint-disable-next-line no-unused-vars
                onChange={checked => {
                  if (plantSelected.includes(plantId)) {
                    setPlantSelected(plantSelected.filter(p => p !== plantId))
                  } else setPlantSelected([...plantSelected, plantId])
                }}
              >
                {plantId}-{plantName}
              </Checkbox>
            </div>
          ))}
        </div>
      </CriteriaRow>
      {/* <CriteriaRow>
        <div style={{ width: '100%', height: '100px', overflow: 'auto' }}>
          <Select
            showSearch
            value={plantSelected}
            style={{ width: '100%' }}
            onChange={plantId => {
              if (plantId.includes('ALL')) {
                setPlantSelected(effectivePlant.map(({ plantId }) => plantId))
              } else setPlantSelected(plantId)
              onChange()
            }}
            mode="multiple"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            allowClear
            placeholder="Select Plant"
          >
            <Select.Option key="ALL" value="ALL">
              ALL
            </Select.Option>
            {effectivePlant.map(({ plantName, plantId }) => (
              <Select.Option key={plantId} value={plantId}>
                {plantName}
              </Select.Option>
            ))}
          </Select>
        </div>
      </CriteriaRow> */}
      <FullHeightSizer heightOffset={350} widthOffset={20}>
        {({ height, width }) => (
          <Content style={{ padding: '10px', height, width }}>
            <Tabs activeKey={activeKey} onChange={setActiveKey} type="card">
              {selectedType === EVENT_INVERTER_PERFORMANCE && (
                <Tabs.TabPane key="event-data" tab="Event">
                  <div style={{ height, width }}>
                    <Grid
                      sortEnabled
                      data={data2 || []}
                      headers={SolarNercEventIoHeaders(1000, [], [], true)}
                      altBgColor="#ebebeb"
                      render={virtualizedGridRenderer({
                        autoFixColByKey: false,
                        rowHeaderRender,
                        height: height - 80,
                        width: width - 30,

                        // cellRender: performanceDoubleClick,
                      })}
                      //   fuzzyFilter={fuzzyFilter}
                      isEditable={false}
                      selectionMode="single"
                      selectionType="row"
                      // initialSortOptions={headers}
                    />
                  </div>
                </Tabs.TabPane>
              )}
              <Tabs.TabPane
                key="data"
                tab={
                  selectedType === EVENT_INVERTER_PERFORMANCE
                    ? 'Performance'
                    : 'Data'
                }
              >
                <div style={{ height, width }}>
                  <Grid
                    sortEnabled
                    data={data || []}
                    headers={solarHeaders || []}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 80,
                      width: width - 30,

                      // cellRender: performanceDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    selectionMode="single"
                    selectionType="row"
                    // initialSortOptions={headers}
                  />
                </div>
              </Tabs.TabPane>
              {selectedType === EVENT_INVERTER_PERFORMANCE && (
                <Tabs.TabPane key="event-xml" tab="Event XML">
                  <TextArea
                    value={getEventListXML(data2)}
                    style={{ height: height - 80, width }}
                  />
                </Tabs.TabPane>
              )}
              <Tabs.TabPane
                key="xml"
                tab={
                  selectedType === EVENT_INVERTER_PERFORMANCE
                    ? 'Performance XML'
                    : 'XML'
                }
              >
                <TextArea
                  value={xmlString}
                  style={{ height: height - 80, width }}
                />
              </Tabs.TabPane>
              <Tabs.TabPane key="errors" tab="Warnings/Errors">
                <JcTmpErrorTable
                  errors={jcTmpErrors}
                  scroll={{ y: height - 120 }}
                />
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(SolarFileCreation)
